<button mat-flat-button [disabled]="isBtnDisabled" color="{{ color }}" (click)="onClickButton($event)">
  {{ text }}
</button>
